import SectionControl from './SectionControl';

export default SectionControl;
